export const GET_COMMENTS__REQUEST = 'COMMENTS_TYPE__GET_COMMENTS__REQUEST'
export const GET_COMMENTS__SUCCESS = 'COMMENTS_TYPE__GET_COMMENTS__SUCCESS'
export const GET_COMMENTS__FAILURE = 'COMMENTS_TYPE__GET_COMMENTS__FAILURE'
export const SEND_COMMENT__REQUEST = 'COMMENTS_TYPE__SEND_COMMENT__REQUEST'
export const SEND_COMMENT__SUCCESS = 'COMMENTS_TYPE__SEND_COMMENT__SUCCESS'
export const SEND_COMMENT__FAILURE = 'COMMENTS_TYPE__SEND_COMMENT__FAILURE'
